import React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { TrustStats } from './components/sections/TrustStats';
import { Transformation } from './components/sections/Transformation';
import { TaglineCta } from './components/sections/TaglineCta';
import { KeyBenefits } from './components/sections/KeyBenefits';
import { Tomos } from './components/sections/Tomos';
import { ExerciseCardDetail } from './components/sections/ExerciseCardDetail';
import { InsideLook } from './components/sections/InsideLook';
import { Testimonials } from './components/sections/Testimonials';
import { SystemSteps } from './components/sections/SystemSteps';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { ValueComparison } from './components/sections/ValueComparison';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCTA } from './components/ui/StickyCTA';
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3rbzmog3k10py">
      <div className="w-full min-h-full bg-white font-body text-ink" data-id="element-1" data-mp="3rd19tixuhdo1">
        <main data-id="element-2" data-mp="4wwnrzgd0hb">
          <Hero data-id="element-3" data-mp="5gfdawxfswe" />
          <TrustStats data-id="element-4" data-mp="82kz509bybz" />
          <Transformation data-id="element-5" data-mp="2zl3cjn8vpa6d" />
          <TaglineCta data-id="element-6" data-mp="2zlv8x0aavbxp" />
          <KeyBenefits data-id="element-7" data-mp="2zmo557bmuj1l" />
          <Tomos data-id="element-8" data-mp="2zn6cp03qwjot" />
          <ExerciseCardDetail data-id="element-9" data-mp="33mowfsjtyoq2" />
          <InsideLook data-id="element-10" data-mp="33nq6btp41567" />
          <Testimonials data-id="element-11" data-mp="33n6xr3lcnt4u" />
          <SystemSteps data-id="element-12" data-mp="33oi2b5mmd4x0" />
          <Bonuses data-id="element-13" data-mp="38m1jadapbvsn" />
          <Pricing data-id="element-14" data-mp="38kqcs5pvg9xu" />
          <ValueComparison data-id="element-15" data-mp="38k6ugnwb7jja" />
          <Guarantee data-id="element-16" data-mp="38o4h3ji3it7x" />
          <FAQ data-id="element-17" data-mp="3dkl60fx4dbm2" />
          <FinalCTA data-id="element-18" data-mp="3dl4l7ovdxlwe" />
        </main>
        <Footer data-id="element-19" data-mp="3dm5z013scmht" />
        <StickyCTA data-id="element-20" data-mp="3dii3iwes5q0g" />
      </div>
    </LazyMotion>;
}